import * as types from '../actionTypes/AddressingConstActionTypes';

function AddressingConstReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.GET_ADDRESSING_ZIP_CODE: {
            const isLoading = true;
            const isSuccess = false;
            const response = {};
            return { ...state, isLoading, isSuccess, response, error: {} };
        }
        case types.GET_ADDRESSING_ZIP_CODE_SUCCESS: {
            return { ...state, ...action.payload, error: {} };
        }
        case types.GET_ADDRESSING_ZIP_CODE_ERROR: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}

AddressingConstReducer.reducerName = 'addressingConstDetails';
export default AddressingConstReducer;
